<template>
  <div>
    <Row v-for="img in imgs" :key="img" type="flex" justify="center" align="middle" class="img-row">
      <Col span="14">
        <img class="img-item" :src="img" />
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      defalult: function() {
        return []
      }
    }
  },
  data() {
    return {
      imgs: []
    }
  },
  methods: {
    renderImgs() {

      this.imgs = [...this.data];
    },
  }
}
</script>

<style lang="scss" scoped>
.img-row{
  padding: 12px 0;
}
.img-item{
  width: 600px;
}
</style>


// WEBPACK FOOTER //
// src/pages/cleaner/order-list/order-img.vue